export default {
  value: {
    type: undefined,
    required: true,
    note: 'Valor do input'
  },
  title: {
    type: String,
    default: '',
    note: 'Título do campo'
  },
  disabled: {
    type: Boolean,
    default: false,
    note: 'Indica se o campo vai ficar desabilitado'
  },
  colorInput: {
    type: String,
    default: ''
  },
  colorBgField: {
    type: String,
    default: ''
  },
  icon: {
    type: String,
    default: '',
    note: 'Icone do input'
  },
  colorError: {
    type: String,
    default: '#ED1651',
    note: 'Cor da borda pra quando der erro'
  },
  sizeIcon: {
    type: Number,
    default: 20,
    note: 'Tamanho do icone'
  },
  placeholder: {
    type: String,
    default: '',
    note: 'Placeholder do input'
  },
  typeInput: {
    type: String,
    default: 'text',
    note: 'Tipo do input'
  },
  clickIcon: {
    type: Boolean,
    default: false,
    note: 'Ação de clique no icone'
  },
  errorMessage: {
    type: String,
    default: null,
    note: 'Mensagem de erro que aparecia, tiraram isso :/'
  },
  success: {
    type: Boolean,
    default: false,
    note: 'Indica se teve sucesso ou não'
  },
  colorText: {
    type: String,
    default: '#60656C',
    note: 'Cor de texto'
  },
  onlyNumber: {
    type: Boolean,
    default: false,
    note: 'Só deixa escrever números'
  },
  min: {
    type: [String, Number],
    required: false,
    default: '',
    note: 'Minimo de caracteres disponiveis no input'
  },
  max: {
    type: [String, Number],
    required: false,
    default: '',
    note: 'Máximo de caracteres disponiveis no input'
  },
  onlyText: {
    type: Boolean,
    required: false,
    default: false,
    note: 'Só deixa escrever texto'
  },
  onlyAlphaNum: {
    type: Boolean,
    required: false,
    default: false
  },
  onlylowerCase: {
    type: Boolean,
    require: false,
    default: false,
    note: 'Transforma em caracteres pequenos'
  },
  colorIcon: {
    type: String,
    required: false,
    default: '',
    note: 'Cor do icone'
  },
  colorPlaceholder: {
    type: String,
    required: false,
    default: '#707070',
    note: 'Cor do placeholder'
  },
  mask: {
    type: [String, Array, Object],
    required: false,
    note: 'Máscara do campo nativo'
  },
  name: {
    type: String,
    default: ''
  },
  onlyUpperCase: {
    type: Boolean,
    default: true
  },
  emailMask: {
    type: Boolean,
    default: false
  },
  textAlign: {
    type: String,
    default: 'start'
  }
}
